import { Notification as AlertComp } from '@Calix-Commerce/design-system/components';
import styled from '@emotion/styled';

export const Alert = styled(AlertComp)`
  width: 100%;
  margin-top: 15px;
  padding: 6px 15px;
  text-align: left;
`;
